(function ($) {
	$.fn.tableToChart = function (options) {
		var settings = $.extend({
			chartOptions: {}
		}, options);

		return this.each(function () {
			var table = $(this),
				canvas = $('<canvas>'),
				wrapper = $('<div>').addClass(table.attr('class')).append(canvas).insertAfter(table);
		
			// Get data
			var labels = [],
				filters = {},
				headers = table.find('thead th').map(function () {
					var cell = $(this);
					return {
						name: cell.text(),
						index: cell.index(),
						type: cell.data('type')
					};
				}).get(),
				tableData = table.find('tbody tr').map(function () {
					var row = $(this),
						children = row.children(),
						values = {};

					$.each(headers, function (i, header) {
						var cell = children.eq(header.index),
							value = cell.data('value') || cell.text();

						if (header.type == 'label') {
							// Add label (if not already exists)
							if (labels.indexOf(value) == -1) labels.push(value);
						} else {
							if (header.type == 'filter') {
								// Add filter (if not already exists)
								if (!filters[header.name]) filters[header.name] = [value];
								else if (filters[header.name].indexOf(value) == -1) filters[header.name].push(value);
							} else if (header.type == 'dataset') {
								// Dataset are numbers
								value = parseFloat(value);
							}

							// Add table data
							if (!values[header.type]) values[header.type] = {};
							values[header.type][header.name] = value;
						}
					});

					return values;
				}).get();

			// Get datasets
			var getDatasets = function (filters) {
				var datasets = [];

				$.each($.grep(tableData, function (data) {
					// Filter table data
					return Object.identical(data.filter, filters);
				}), function (i, data) {
					var j = 0;
					$.each(data.dataset, function (name, value) {
						// Create dataset
						if (!datasets[j]) datasets[j] = $.extend({
							label: name,
							data: [],
							yAxisID: 'y-axis-' + j
						}, Chart.defaults.global.datasets[j]);
						// Add data
						datasets[j].data.push(value);
						j++;
					});
				});

				return datasets;
			};

			// Add filter controls
			var filter = {},
				form = $('<div class="select form">');

			$.each(filters, function (name, values) {
				// Set initial filter
				if (!filter[name]) filter[name] = values[0];

				// Add label and select
				$('<p>').append(
					$('<label>').text(name),
					$('<select>').append($.map(values, function (value) {
						return $('<option>', {
							text: value
						});
					})).change(function () {
						// Update filter
						filter[name] = this.value;
						chart.data.datasets = getDatasets(filter);
						chart.update();
					})
				).appendTo(form);
			});
			form.insertBefore(table);

			// Create chart
			var chart = new Chart(canvas, {
				type: 'line',
				data: {
					labels: labels,
					datasets: getDatasets(filter)
				},
				options: settings.chartOptions
			});

			// Hide table
			table.hide();
		});
	};
}(jQuery));